var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fd5eff60bd74137ec0eccbcd16f484de0e395f49"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website-next@upflow"]={id:"fd5eff60bd74137ec0eccbcd16f484de0e395f49"};
      